export const ChannelStatus = {
  Live: 'live',
  Ended: 'ended',
  Offline: 'offline',
  Deleted: 'deleted'
}

export const FetchLiveChannelsQueryType = {
  All: 'all',
  Popular: 'popular',
  Trending: 'trending',
  TopRated: 'top_rated'
}

export const isLiveStreamingChannelLive = (channel) => {
  return channel && channel.status === ChannelStatus.Live
} 

export const isLiveStreamingChannelOffline = (channel) => {
  return channel && channel.status === ChannelStatus.Offline
}
